import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative group overflow-hidden rounded-sm font-semibold tracking-wide text-navy-950 
        transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.3)]
        hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]
        ${fullWidth ? 'w-full' : 'px-8 py-4'}
        ${className}
      `} data-id="element-17">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-gold bg-[length:200%_auto] animate-shimmer" data-id="element-18" />

      {/* Button content */}
      <span className="relative z-10 flex items-center justify-center gap-2 text-sm md:text-base uppercase tracking-widest" data-id="element-19">
        {children}
      </span>
    </motion.button>;
}